import { Tooltip } from 'antd';
import { TooltipPropsWithOverlay, TooltipPropsWithTitle } from 'antd/lib/tooltip';
import './VtxTooltip.scss';
import * as React from 'react';
import { FunctionComponent } from 'react';
import classNames from 'classnames';
import { IAutomatable, preventDataAutomationOverriding } from '../../helpers/IAutomatable';

export interface VtxTooltipPropsWithOverlay extends Omit<TooltipPropsWithOverlay, 'color'>, IAutomatable {}
export interface VtxTooltipPropsWithTitle extends Omit<TooltipPropsWithTitle, 'color'>, IAutomatable {}
export type VtxTooltipProps = VtxTooltipPropsWithTitle | VtxTooltipPropsWithOverlay;

export const VtxTooltip: FunctionComponent<VtxTooltipProps> = React.memo((props: VtxTooltipProps) => {
    const automationClass = 'vtx-tool-tip';
    const { overlayClassName, title, ...otherProps } = preventDataAutomationOverriding(props);

    const classNamesCombined = classNames(automationClass, overlayClassName);

    return (
        <Tooltip
            title={<span data-automation-class={automationClass}>{title}</span>}
            overlayClassName={classNamesCombined}
            {...otherProps}
        />
    );
});
